<h2 mat-dialog-title>{{data.username}}</h2>
<mat-dialog-content>
  @if(data.disabled){
  <div>
    {{'Are you sure you want to enable this user?' | translate}} {{data.username}}?
  </div>
  }@else {
  {{'Are you sure you want to disable this user?' | translate}} {{data.username}}?
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="dialogRef.close(false)">No</button>
  <button mat-button [disabled]="isloading" cdkFocusInitial
    (click)="data.disabled ? enableUser() : disableUser()">Yes</button>
</mat-dialog-actions>